// extracted by mini-css-extract-plugin
export default {"preview":"zvv20l0_5xrg8x4rb69v"};